import { MunicipalityModel } from './municipality.model';
import {
  BuildingMarker,
  BuildingMarkerGroup,
} from './../../modules/buildings-map/buildings-map.component';
import { BuildingDetails, BuildingModel } from './building.model';

export class ComplexBuildingModel {
  data: BuildingModel[];
  total: number;
  markers: string[];
}
